import { takeEvery } from 'redux-saga/effects';
import { DOWNLOAD_EXCEL_SUCCESS, DownloadExcelAction, } from "./types"

function* downloadExcelFile(action: DownloadExcelAction) {
    if (action.payload && action.payload.data) {
        const res = JSON.parse(action.payload.data.data);
        const blob = new Blob([res.body]);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        const filename = action.payload?.data.headers.fileName;
        const contentType = action.payload?.data.headers.contentType;
        link.download = `${filename}.${contentType}`;
        link.click();
        link.remove();

    }
    return action?.payload?.data;
}



export default function* agentSaga() {
    yield takeEvery(DOWNLOAD_EXCEL_SUCCESS, downloadExcelFile)
}